import styled from 'styled-components'

import { ReactComponent as DocumentIcon } from '../../assets/images/icons/document.svg'
import { Button } from '../button'
import { Icon } from '../icon'
import { GalleryDocumentPreviewProps } from './documents-gallery.types'
import { getDocumentName } from './document-kind'

const Placeholder = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing.s};
    padding: ${theme.spacing.xxl} ${theme.spacing.m};
    border: 1px dashed ${theme.semantic.borderSubtle};
    border-radius: ${theme.radii.container};
    background-color: ${theme.semantic.backgroundSecondary};
    text-align: center;

    > svg {
      width: ${theme.spacing.xxl};
      height: ${theme.spacing.xxl};
    }
  `}
`

const FileName = styled.p`
  ${({ theme }) => `
    margin: 0;
    color: ${theme.semantic.contentPrimary};
    font-size: ${theme.fontSizes.bodySmall};
    font-weight: ${theme.fontWeights.medium};
    overflow-wrap: anywhere;
  `}
`

const Message = styled.p`
  ${({ theme }) => `
    margin: 0;
    color: ${theme.semantic.contentSecondary};
    font-size: ${theme.fontSizes.bodySmall};
  `}
`

const DownloadLink = styled.a`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xxs};
    padding: ${theme.spacing.xs} ${theme.spacing.m};
    border-radius: ${theme.radii.interactive};
    background-color: ${theme.semantic.interactiveDefault};
    color: ${theme.semantic.contentOnBrand};
    font-size: ${theme.fontSizes.button};
    font-weight: ${theme.fontWeights.medium};
    text-decoration: none;

    &:hover {
      background-color: ${theme.semantic.interactiveHover};
    }
  `}
`

export function GalleryDocumentPreview({
  url,
  onShowTranslation,
  labels,
}: Readonly<GalleryDocumentPreviewProps>) {
  const {
    cannotPreview = 'This file type cannot be previewed.',
    download = 'Download',
  } = labels ?? {}

  return (
    <Placeholder data-testid="documents-gallery-document-preview">
      <DocumentIcon />
      <FileName>{getDocumentName(url)}</FileName>
      <Message>{cannotPreview}</Message>
      <DownloadLink
        href={url}
        download
        target="_blank"
        rel="noreferrer"
        data-testid="documents-gallery-download"
      >
        <Icon name="download" size="s" />
        {download}
      </DownloadLink>
      {onShowTranslation && (
        <Button
          variant="secondary"
          size="small"
          startIcon="translation"
          onClick={onShowTranslation}
        >
          Show translation
        </Button>
      )}
    </Placeholder>
  )
}
